export default "__VITE_ASSET__0ef943da__"